module.exports = __webpack_public_path__ + "img/fwlc.3493cec4.png";